import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import React, { useEffect } from 'react'
import {isSelfService} from '../Utils/hooks'

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        backgroundColor: '#fff',
        height: '100vh',
        padding: theme.spacing(3),
        fontSize: 24,
        justifyContent: 'center',
        display: 'flex',
    },
}))

export const ErrorContainer = () => {
    const { classes } = useStyles()

    useEffect(() => {
        if (isSelfService() && process.env.NODE_ENV === 'production') {
            setInterval(() => {
                window.location.href = '/self-service'
            }, 5000)
        }
    }, [])

    return isSelfService() ? <div className={classes.root}>Tapahtui virhe</div> : <div className={classes.root}>Virhe, sivua ei löytynyt.</div>
}
